import { Box, type SxProps } from '@mui/material';
import type { FC, ReactNode } from 'react';

interface RowProps {
  children: ReactNode;
  justifyContent?: string;
  alignItems?: string;
  spacing?: string;
  width?: string;
  sx?: SxProps;
  onClick?: () => void;
}

export const Row: FC<RowProps> = ({
  children,
  justifyContent = 'flex-start',
  alignItems = 'center',
  spacing,
  width,
  sx,
  onClick,
}) => {
  return (
    <Box
      onClick={onClick}
      sx={{
        display: 'flex',
        justifyContent,
        alignItems,
        gap: spacing,
        width,
        ...sx,
      }}
    >
      {children}
    </Box>
  );
};
